import * as R from 'ramda'

//noinspection JSUnusedGlobalSymbols
export default {

    all: state => Object.values(state.entities),

    allByProductId: (state, getters) => productId => {
        return R.filter(R.propEq('product', productId), getters['all'])
    },

    byId: state => id => {
        return R.prop(id, state.entities)
    }

}


